import type {
  DropdownClearOptions,
  DropdownClearPlacementWithDefault,
} from '~/chords/Select/components/DropdownSingleSelect/types';

/**
 * Normalize clear control placements to a consistent array shape.
 * @param placements - Raw placements from clearOptions.
 * @returns An array of placement values. Defaults to ['default'] when undefined.
 */
export function normalizeClearPlacements(
  placements: DropdownClearOptions['placements'],
): DropdownClearPlacementWithDefault[] {
  if (placements === undefined) {
    return ['default'];
  }

  if (Array.isArray(placements)) {
    return placements;
  }

  return [placements];
}
